// extracted by mini-css-extract-plugin
export default {"chartContent":"Chartgraph_chartContent__1rmva"};